import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect, useId } from 'react';
import { ChevronLeftIcon } from '../../icons';
import { Modal, useModal } from '../modal';
import { DatePickerCalendar } from './calendar';
export function DatePickerMobileContentView({ title = 'Select date', onBack, selectedDate, visibleDate, minValue, maxValue, onDateChange, onMonthChange, onYearChange, onPreviousMonth, onNextMonth, }) {
    return (_jsxs(Fragment, { children: [_jsx(Modal.Header, { children: _jsxs("div", { className: "flex items-center gap-stack-tight", children: [onBack && (_jsx("button", { type: "button", onClick: onBack, className: "p-stack-tight -ml-stack-tight border border-transparent hover:border-border rounded-surface transition-colors", children: _jsx(ChevronLeftIcon, { className: "size-4 text-fg-muted" }) })), _jsx(Modal.Heading, { children: title })] }) }), _jsx(Modal.Content, { className: "p-0 flex justify-center", children: _jsx(DatePickerCalendar, { selectedDate: selectedDate, visibleDate: visibleDate, minValue: minValue, maxValue: maxValue, onDateChange: onDateChange, onMonthChange: onMonthChange, onYearChange: onYearChange, onPreviousMonth: onPreviousMonth, onNextMonth: onNextMonth }) })] }));
}
export function DatePickerMobileContent({ title = 'Select date', isOpen, onClose, selectedDate, visibleDate, minValue, maxValue, onDateChange, onMonthChange, onYearChange, onPreviousMonth, onNextMonth, }) {
    const datePickerId = useId();
    const parentModal = useModal(true);
    const handleDateChange = (date) => {
        onDateChange(date);
        onClose();
    };
    useEffect(() => {
        if (!parentModal || !isOpen) {
            return;
        }
        parentModal.push({
            id: datePickerId,
            component: (_jsx(DatePickerMobileContentView, { title: title, onBack: onClose, selectedDate: selectedDate, visibleDate: visibleDate, minValue: minValue, maxValue: maxValue, onDateChange: handleDateChange, onMonthChange: onMonthChange, onYearChange: onYearChange, onPreviousMonth: onPreviousMonth, onNextMonth: onNextMonth })),
        });
        // Stacked view is a frozen element — re-push when calendar state changes.
        // parentModal identity changes on every stack update — omit it from deps.
    }, [isOpen, datePickerId, selectedDate, visibleDate, minValue, maxValue]);
    useEffect(() => {
        if (!parentModal || !isOpen) {
            return;
        }
        return () => {
            parentModal.pop();
        };
        // parentModal identity changes on every stack update — only react to open/close
    }, [isOpen, datePickerId]);
    if (!isOpen || parentModal) {
        return null;
    }
    return (_jsx(Modal, { onClose: onClose, children: _jsx(DatePickerMobileContentView, { title: title, selectedDate: selectedDate, visibleDate: visibleDate, minValue: minValue, maxValue: maxValue, onDateChange: handleDateChange, onMonthChange: onMonthChange, onYearChange: onYearChange, onPreviousMonth: onPreviousMonth, onNextMonth: onNextMonth }) }));
}
